<template>
    <v-col class="mb-5">
        <table v-if="showHeader">
            <tr>
                <th>SOP Title</th>
                <th colspan="5">{{ title }}</th>
            </tr>
            <tr>
                <th>Document Number</th>
                <th>Version</th>
                <th>Effective Date</th>
                <th>Review Date</th>
                <th>Supersedes</th>
                <th>Page Number</th>
            </tr>
            <tr>
                <td>{{ documentNumber }}</td>
                <td>{{ version }}</td>
                <td>{{ effectiveDate }}</td>
                <td>{{ reviewDate }}</td>
                <td>{{ supersedes }}</td>
                <td>N/A</td>
            </tr>
        </table>
    </v-col>
</template>

<script>
export default {
    name: 'SSFormHeader',
    props: {
        title: {
            type: String,
            required: true,
        },
        documentNumber: {
            type: String,
            required: true,
        },
        version: {
            type: String,
            required: true,
        },
        effectiveDate: {
            type: String,
            required: true,
        },
        reviewDate: {
            type: String,
            required: true,
        },
        supersedes: {
            type: String,
            required: true,
        },
        showHeader: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped></style>
